export default {
  common: {
    breadcrumb: {
      home: '首页',
    },
    cta: '欢迎了解更多飞狼业务',
  },
  heroTitle: 'UI/UX 设计 & 开发',
  heroSubtitle: 'UI/UX Design & Development',
  heroDesc: '以用户需求为核心，融合UI/UX设计与开发能力，打造兼具良好体验与实际业务价值的数字化产品。',
  intro: [
    '从用户需求与业务场景出发，提供涵盖用户研究、信息架构、交互设计、UI视觉设计及前端开发的全流程服务。',
    '通过深入理解企业业务与用户使用习惯，将复杂的业务逻辑转化为直观、高效、易用的产品体验，并结合实际技术需求推动设计与开发协同落地。',
    '无论是企业管理系统、业务平台还是面向用户的数字化产品，我们都通过持续优化产品体验与功能实现，帮助企业提升产品价值与用户满意度。',
  ],
  servicesTitle: '业务范围',
  servicesTitleEn: 'Our Services',
  servicesTitleDesc: '飞狼为您从0打造，从设计到开发一体的细致服务。',
  services: [
    {
      icon: 'uiux/manufacturing.svg',
      title: 'APP移动端',
      titleEn: 'Mobile Application',
      desc: '面向手机、平板、智能手表等移动终端，融合UI/UX设计与开发能力，根据不同设备与使用场景打造直观、流畅且一致的用户体验，帮助企业将数字化服务延伸至更多终端。',
    },
    {
      icon: 'uiux/aerospace.svg',
      title: '网页',
      titleEn: 'Web',
      desc: '面向企业官网、Web应用及管理后台，提供用户研究、UI/UX设计与前后端开发服务，打造清晰、高效、易用的数字化平台。',
    },
    {
      icon: 'uiux/utilities.svg',
      title: '小程序',
      titleEn: 'Mini Program',
      desc: '提供微信小程序从产品规划、UI/UX设计、功能开发到上线运维的一体化服务，结合企业业务需求与用户使用场景，打造便捷、高效的数字化应用，并通过持续维护与功能迭代保障系统稳定运行。',
    },
  ],
  solutionsTitle: '解决方案',
  solutionsTitleEn: 'Our Solutions',
  solutionsDesc: '我们的设计开发团队拥有丰富的行业经验，源于需求放眼世界',
  solutions: [
    {
      icon: 'uiux/consumer.svg',
      title: '消费',
      titleEn: 'Consumer',
      desc: '面向日常消费场景，打造便捷、直观的数字化产品体验。',
    },
    {
      icon: 'uiux/defense.svg',
      title: '医疗系统',
      titleEn: 'Healthcare System',
      desc: '面向医疗器材企业，覆盖内部管理与外部业务的综合数字化系统。',
    },
    {
      icon: 'uiux/hotel.svg',
      title: '企业服务',
      titleEn: 'Business Dashboard',
      desc: '整合企业运营数据与关键信息，通过可视化Dashboard提升管理与决策效率。',
    },
    {
      icon: 'uiux/medal.svg',
      title: '金融',
      titleEn: 'Finance',
      desc: '简化金融服务流程，提供清晰、高效且易用的数字化体验。',
    },
    {
      icon: 'uiux/profile.svg',
      title: '资讯 & 社交',
      titleEn: 'Information & Community',
      desc: '结合资讯、问答与互动机制，提升用户参与度与平台活跃度。',
    },
    {
      icon: 'uiux/shopping-cart.svg',
      title: '电商购物',
      titleEn: 'E-Commerce',
      desc: '从商品浏览、购买到订单管理，打造流畅、直观的线上购物体验。',
    },
  ],
  contact: '联系我们',
};
